import { apiClient } from './apiClient';
import { debugLogger } from '../utils/debugLogger';
import { Post, PostModerationStatus } from './postService';

interface ApiResponse<T> {
  result: string;
  message: string;
  data: T;
}

export interface PendingModerationPost extends Post {
  moderationStatus: PostModerationStatus.PENDING;
  isSensitive: boolean;
  isViolent: boolean;
}

export interface ModerationResponse {
  posts: PendingModerationPost[];
  totalElements: number;
  totalPages: number;
  currentPage: number;
}

export interface ModeratePostRequest {
  status: PostModerationStatus.APPROVED | PostModerationStatus.REJECTED;
  reason?: string;
}

class ModerationService {
  private baseUrl = '/api/admin/moderation';

  async getPendingPosts(page = 0, size = 20): Promise<ModerationResponse> {
    const endpoint = `${this.baseUrl}/pending`;
    debugLogger.logApiCall('GET', endpoint, { page, size });
    try {
      const response = await apiClient.get<ApiResponse<any>>(endpoint, {
        params: { page, size }
      });
      debugLogger.logApiResponse('GET', endpoint, response);
      
      // Backend returns Spring Page format with 'content' field
      const pageData = response.data;
      return {
        posts: pageData.content || [],
        totalElements: pageData.totalElements || 0,
        totalPages: pageData.totalPages || 0,
        currentPage: pageData.number || page
      };
    } catch (error) {
      debugLogger.logApiResponse('GET', endpoint, null, error);
      throw error;
    }
  }

  async moderatePost(postId: number, request: ModeratePostRequest): Promise<Post> {
    const endpoint = `${this.baseUrl}/posts/${postId}`;
    debugLogger.logApiCall('PUT', endpoint, request);
    try {
      const response = await apiClient.put<ApiResponse<Post>>(endpoint, request);
      debugLogger.logApiResponse('PUT', endpoint, response);
      return response.data;
    } catch (error) {
      debugLogger.logApiResponse('PUT', endpoint, null, error);
      throw error;
    }
  }
}

export const moderationService = new ModerationService();


